module.exports = __webpack_public_path__ + "img/illustration-register-v2-dark.687c1176.png";